import { gql } from '@apollo/client';
import { COUNTRY_FRAGMENT } from './country.gql';
import { LOCATION_FRAGMENT } from './location.gql';

export const OFFICE_FRAGMENT = gql`
    ${COUNTRY_FRAGMENT}
    ${LOCATION_FRAGMENT}
    fragment OfficeType on OfficeType {
        id
        country {
            ...CountryType
        }
        address
        phone
        email
        schedule
        location {
            ...CoordinatePointType
        }
    }
`;
